import PartnerCard from "./PartnerCard";
import { useSafeArea, useDeviceType } from "./hooks/useOpenAiGlobal";

interface Partner {
  id?: string;
  name: string;
  tags: string[] | string;
  description: string;
  round?: string;
  fundingRound?: string;
  footprint?: string;
  score?: number;
  matchScore?: number;
  website?: string;
  source_thread_id?: string;
}

interface PartnerGridProps {
  partners: Partner[];
  requestorDomain?: string;
  userEmail?: string;
  onEmailSubmitted?: (email: string) => void;
}

const PartnerGrid = ({
  partners,
  requestorDomain,
  userEmail,
  onEmailSubmitted,
}: PartnerGridProps) => {
  // Use safe area insets to prevent content from being hidden by OpenAI input field
  const safeArea = useSafeArea();
  const deviceType = useDeviceType();
  const isMobile = deviceType === "mobile";
  
  return (
    <div style={{ paddingBottom: `${safeArea.bottom + 16}px` }}>
      <div className="mb-6 pt-6 px-4 md:px-6">
        <h1 className="text-2xl font-semibold text-foreground">
          All partner matches
        </h1>
        <p className="text-sm mt-1 text-muted-foreground">
          Compare partners and request intros.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4 md:px-6">
        {partners.map((partner, index) => (
          <div
            key={partner.id || partner.name || index}
            className="h-full animate-slide-up"
            style={{ animationDelay: `${index * 50}ms` }}
          >
            <PartnerCard
              partner={partner}
              variant="fullscreen"
              requestorDomain={requestorDomain}
              userEmail={userEmail}
              onEmailSubmitted={onEmailSubmitted}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PartnerGrid;
